var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container md-offset"},[_c('nav'),_c('div',{staticClass:"copyright text-center"},[_vm._v("\n      © "+_vm._s(new Date().getFullYear())+"\n      "),_c('a',{attrs:{"href":"https://www.myselfie.com","target":"_blank"}},[_vm._v("myselfie")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }